export enum ProductPropertiesType {
    DisableReceipt = 'WEB_DISABLE_RECEIPT',
    DynamicLength = 'DYNAMIC_LENGTH',
    AllowAmountSelection = 'ALLOW_AMOUNT_SELECTION',
    FixedStartAndEndDate = 'FIXED_START_AND_END_DATE',
    TicketStartDate = 'TICKET_START_DATE',
    TicketEndDate = 'TICKET_END_DATE'
}
